import * as yup from 'yup'
import { InferType } from 'yup'

import { TTranslationFunction } from '@/types'
import { maxLengthSchema } from '@/utils/fieldSchemas'

import { urlSchema } from '../fieldSchemas'

export const BUSINESS_INFO_COMPANY_NAME_MAX_LENGTH = 200
export const BUSINESS_INFO_TITLE_MAX_LENGTH = 200
export const BUSINESS_INFO_SUBTITLE_MAX_LENGTH = 250
export const BUSINESS_INFO_BUTTON_TEXT_MAX_LENGTH = 50

export const getBusinessInfoFormSchema = (t: TTranslationFunction) =>
	yup
		.object({
			companyName: maxLengthSchema(
				BUSINESS_INFO_COMPANY_NAME_MAX_LENGTH,
				t,
			).required(t('ui__field_validation_errors__generic__required')),

			title: maxLengthSchema(BUSINESS_INFO_TITLE_MAX_LENGTH, t).notRequired(),

			subtitle: maxLengthSchema(
				BUSINESS_INFO_SUBTITLE_MAX_LENGTH,
				t,
			).notRequired(),

			buttons: yup
				.array(
					yup.object({
						title: maxLengthSchema(BUSINESS_INFO_BUTTON_TEXT_MAX_LENGTH, t).required(
							t('ui__field_validation_errors__generic__required'),
						),
						url: urlSchema(t, { required: true }),
					}),
				)
				.required(),
		})
		.required()

export type TBusinessInfoFields = InferType<
	ReturnType<typeof getBusinessInfoFormSchema>
>

export type TBusinessButton = TBusinessInfoFields['buttons'][number]
